<template>
  <div id="delivery" class="container">
    <SfBreadcrumbs
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs"
    />

    <OrkCmsPage pageId="delivery"/>
  </div>
</template>

<script>
import {SfBreadcrumbs} from "@storefront-ui/vue"
import {OrkCmsPage} from "@/components/Ork";

export default {
  name: "Delivery",
  components: {
    OrkCmsPage,
    SfBreadcrumbs
  },
  data() {
    return {
      breadcrumbs: null,

    }
  },
  created() {
    this.setBreadcrumbs();
  },
  methods: {
    setBreadcrumbs() {

      this.breadcrumbs = [{
        text: this.$i18n.t('Home'),
        link: '/'
      }, {
        text: this.$i18n.t('Delivery'),
      }];

    },
  },
}
</script>

<style lang="scss" scoped>
.error-msg {
  text-align: center;
}
</style>